import { FC } from 'react';
import styles from './SelectOption.css';
import { Checkbox, UIText3 } from '@cian/ui-kit';
import { preventDefault } from 'shared/utils/event';
import { TSelectOptionValue } from 'shared/types/filters';

interface ISelectOptionProps {
  value: TSelectOptionValue;
  label: string;
  marker?: string;
  index: number;
  selected: boolean;
  onClick(e: React.MouseEvent<HTMLDivElement>): void;
}

export const SelectOption: FC<ISelectOptionProps> = ({ selected, label, marker, onClick }) => {
  return (
    <div className={styles['option']} onClick={onClick}>
      <div className={styles['checkbox']}>
        <Checkbox checked={selected} onClick={preventDefault} />
      </div>

      {label}

      {marker && (
        <span className={styles['marker']}>
          <UIText3 fontWeight="bold" color="text-inverted-default">
            {marker}
          </UIText3>
        </span>
      )}
    </div>
  );
};
